var _defs, _g, _g2, _g3, _path, _path2, _path3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenmortalityLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 243.75",
    height: 325,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7ff66bfe3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28 6 L 240 6 L 240 204 L 28 204 Z M 28 6 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "16b81968b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106.425781 -42.195312 L 288.507812 112.625 L 210.855469 203.953125 L 28.773438 49.132812 Z M 106.425781 -42.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "055ac6e455"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106.425781 -42.195312 L 288.507812 112.625 L 210.855469 203.953125 L 28.773438 49.132812 Z M 106.425781 -42.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4991834b69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127 19 L 374.808594 19 L 374.808594 232 L 127 232 Z M 127 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d27be59f0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.664062 15.652344 L 232.9375 15.652344 L 232.9375 235.925781 L 12.664062 235.925781 Z M 12.664062 15.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "81fca5b5c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.800781 15.652344 C 61.972656 15.652344 12.664062 64.960938 12.664062 125.789062 C 12.664062 186.617188 61.972656 235.925781 122.800781 235.925781 C 183.628906 235.925781 232.9375 186.617188 232.9375 125.789062 C 232.9375 64.960938 183.628906 15.652344 122.800781 15.652344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.263187, 116.142939)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 95.484375 0 L 95.359375 -55.703125 L 68.03125 -9.8125 L 58.359375 -9.8125 L 31.171875 -54.515625 L 31.171875 0 L 11.015625 0 L 11.015625 -92.84375 L 28.78125 -92.84375 L 63.53125 -35.140625 L 97.75 -92.84375 L 115.390625 -92.84375 L 115.65625 0 Z M 95.484375 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7ff66bfe3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16b81968b4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#055ac6e455)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 210.855469 203.949219 L 201.066406 195.628906 C 239.28125 150.683594 233.921875 83.125 189.117188 45.03125 C 144.3125 6.9375 76.773438 12.511719 38.558594 57.453125 L 28.773438 49.132812 C 71.589844 -1.226562 147.265625 -7.46875 197.464844 35.214844 C 247.664062 77.898438 253.671875 153.59375 210.855469 203.949219 Z M 210.855469 203.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4991834b69)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.751343, -0.00253697, 0.00252982, 0.749227, 233.287008, 116.15919)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00224376 12.498549 L 171.517995 12.500599 ",
    stroke: "#000000",
    strokeWidth: 25,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000046, 0.750182, -0.749232, 0.000000000000000046, 100.194778, 167.993201)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00135127 13.497493 L 73.907801 13.497493 ",
    stroke: "#e50101",
    strokeWidth: 27,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000046, 0.746765, -0.749232, 0.000000000000000046, 132.755781, 130.905507)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000994869 13.500708 L 123.408275 13.500708 ",
    stroke: "#ec4543",
    strokeWidth: 27,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000046, 0.750191, -0.749232, 0.000000000000000046, 167.468569, 95.41049)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000444555 13.497965 L 170.784139 13.497965 ",
    stroke: "#e50101",
    strokeWidth: 27,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d27be59f0b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81fca5b5c2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.748079, 0, 0, 0.748079, 12.66334, 15.651228)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 147.227112 0.00149173 C 65.914626 0.00149173 0.000965302 65.915152 0.000965302 147.227639 C 0.000965302 228.540126 65.914626 294.453786 147.227112 294.453786 C 228.539599 294.453786 294.45326 228.540126 294.45326 147.227639 C 294.45326 65.915152 228.539599 0.00149173 147.227112 0.00149173 ",
    stroke: "#000000",
    strokeWidth: 48,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.246238, 163.497342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5625 0.21875 C 6.257812 0.21875 5.082031 -0.0625 4.03125 -0.625 C 2.988281 -1.1875 2.171875 -1.957031 1.578125 -2.9375 C 0.992188 -3.925781 0.703125 -5.035156 0.703125 -6.265625 C 0.703125 -7.503906 0.992188 -8.613281 1.578125 -9.59375 C 2.171875 -10.582031 2.988281 -11.359375 4.03125 -11.921875 C 5.082031 -12.484375 6.257812 -12.765625 7.5625 -12.765625 C 8.863281 -12.765625 10.035156 -12.484375 11.078125 -11.921875 C 12.117188 -11.359375 12.9375 -10.582031 13.53125 -9.59375 C 14.125 -8.613281 14.421875 -7.503906 14.421875 -6.265625 C 14.421875 -5.035156 14.125 -3.925781 13.53125 -2.9375 C 12.9375 -1.957031 12.117188 -1.1875 11.078125 -0.625 C 10.035156 -0.0625 8.863281 0.21875 7.5625 0.21875 Z M 7.5625 -2.265625 C 8.300781 -2.265625 8.96875 -2.429688 9.5625 -2.765625 C 10.164062 -3.109375 10.632812 -3.582031 10.96875 -4.1875 C 11.3125 -4.800781 11.484375 -5.492188 11.484375 -6.265625 C 11.484375 -7.046875 11.3125 -7.738281 10.96875 -8.34375 C 10.632812 -8.957031 10.164062 -9.429688 9.5625 -9.765625 C 8.96875 -10.109375 8.300781 -10.28125 7.5625 -10.28125 C 6.820312 -10.28125 6.148438 -10.109375 5.546875 -9.765625 C 4.953125 -9.429688 4.484375 -8.957031 4.140625 -8.34375 C 3.804688 -7.738281 3.640625 -7.046875 3.640625 -6.265625 C 3.640625 -5.492188 3.804688 -4.800781 4.140625 -4.1875 C 4.484375 -3.582031 4.953125 -3.109375 5.546875 -2.765625 C 6.148438 -2.429688 6.820312 -2.265625 7.5625 -2.265625 Z M 7.5625 -2.265625 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.875459, 163.497342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.921875 -12.546875 C 8.023438 -12.546875 8.988281 -12.359375 9.8125 -11.984375 C 10.632812 -11.617188 11.265625 -11.09375 11.703125 -10.40625 C 12.140625 -9.726562 12.359375 -8.925781 12.359375 -8 C 12.359375 -7.070312 12.140625 -6.265625 11.703125 -5.578125 C 11.265625 -4.890625 10.632812 -4.363281 9.8125 -4 C 8.988281 -3.632812 8.023438 -3.453125 6.921875 -3.453125 L 4.390625 -3.453125 L 4.390625 0 L 1.484375 0 L 1.484375 -12.546875 Z M 6.75 -5.828125 C 7.625 -5.828125 8.285156 -6.015625 8.734375 -6.390625 C 9.191406 -6.765625 9.421875 -7.300781 9.421875 -8 C 9.421875 -8.695312 9.191406 -9.234375 8.734375 -9.609375 C 8.285156 -9.984375 7.625 -10.171875 6.75 -10.171875 L 4.390625 -10.171875 L 4.390625 -5.828125 Z M 6.75 -5.828125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.497295, 163.497342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.203125 -2.328125 L 11.203125 0 L 1.484375 0 L 1.484375 -12.546875 L 10.96875 -12.546875 L 10.96875 -10.21875 L 4.375 -10.21875 L 4.375 -7.484375 L 10.203125 -7.484375 L 10.203125 -5.234375 L 4.375 -5.234375 L 4.375 -2.328125 Z M 11.203125 -2.328125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.025818, 163.497342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13 -12.546875 L 13 0 L 10.609375 0 L 4.359375 -7.609375 L 4.359375 0 L 1.484375 0 L 1.484375 -12.546875 L 3.890625 -12.546875 L 10.125 -4.921875 L 10.125 -12.546875 Z M 13 -12.546875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.246238, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.90625 0 L 12.890625 -7.53125 L 9.1875 -1.328125 L 7.890625 -1.328125 L 4.21875 -7.359375 L 4.21875 0 L 1.484375 0 L 1.484375 -12.546875 L 3.890625 -12.546875 L 8.578125 -4.75 L 13.203125 -12.546875 L 15.59375 -12.546875 L 15.625 0 Z M 12.90625 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.86492, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5625 0.21875 C 6.257812 0.21875 5.082031 -0.0625 4.03125 -0.625 C 2.988281 -1.1875 2.171875 -1.957031 1.578125 -2.9375 C 0.992188 -3.925781 0.703125 -5.035156 0.703125 -6.265625 C 0.703125 -7.503906 0.992188 -8.613281 1.578125 -9.59375 C 2.171875 -10.582031 2.988281 -11.359375 4.03125 -11.921875 C 5.082031 -12.484375 6.257812 -12.765625 7.5625 -12.765625 C 8.863281 -12.765625 10.035156 -12.484375 11.078125 -11.921875 C 12.117188 -11.359375 12.9375 -10.582031 13.53125 -9.59375 C 14.125 -8.613281 14.421875 -7.503906 14.421875 -6.265625 C 14.421875 -5.035156 14.125 -3.925781 13.53125 -2.9375 C 12.9375 -1.957031 12.117188 -1.1875 11.078125 -0.625 C 10.035156 -0.0625 8.863281 0.21875 7.5625 0.21875 Z M 7.5625 -2.265625 C 8.300781 -2.265625 8.96875 -2.429688 9.5625 -2.765625 C 10.164062 -3.109375 10.632812 -3.582031 10.96875 -4.1875 C 11.3125 -4.800781 11.484375 -5.492188 11.484375 -6.265625 C 11.484375 -7.046875 11.3125 -7.738281 10.96875 -8.34375 C 10.632812 -8.957031 10.164062 -9.429688 9.5625 -9.765625 C 8.96875 -10.109375 8.300781 -10.28125 7.5625 -10.28125 C 6.820312 -10.28125 6.148438 -10.109375 5.546875 -9.765625 C 4.953125 -9.429688 4.484375 -8.957031 4.140625 -8.34375 C 3.804688 -7.738281 3.640625 -7.046875 3.640625 -6.265625 C 3.640625 -5.492188 3.804688 -4.800781 4.140625 -4.1875 C 4.484375 -3.582031 4.953125 -3.109375 5.546875 -2.765625 C 6.148438 -2.429688 6.820312 -2.265625 7.5625 -2.265625 Z M 7.5625 -2.265625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.494141, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.484375 0 L 7.0625 -3.5 L 4.390625 -3.5 L 4.390625 0 L 1.484375 0 L 1.484375 -12.546875 L 6.921875 -12.546875 C 8.023438 -12.546875 8.988281 -12.359375 9.8125 -11.984375 C 10.632812 -11.617188 11.265625 -11.09375 11.703125 -10.40625 C 12.140625 -9.726562 12.359375 -8.925781 12.359375 -8 C 12.359375 -7.0625 12.132812 -6.253906 11.6875 -5.578125 C 11.238281 -4.898438 10.601562 -4.382812 9.78125 -4.03125 L 12.59375 0 Z M 9.421875 -8 C 9.421875 -8.695312 9.191406 -9.234375 8.734375 -9.609375 C 8.285156 -9.984375 7.625 -10.171875 6.75 -10.171875 L 4.390625 -10.171875 L 4.390625 -5.8125 L 6.75 -5.8125 C 7.625 -5.8125 8.285156 -6 8.734375 -6.375 C 9.191406 -6.757812 9.421875 -7.300781 9.421875 -8 Z M 9.421875 -8 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.169743, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.09375 -10.171875 L 0.078125 -10.171875 L 0.078125 -12.546875 L 11 -12.546875 L 11 -10.171875 L 6.984375 -10.171875 L 6.984375 0 L 4.09375 0 Z M 4.09375 -10.171875 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.748352, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.75 -2.6875 L 3.921875 -2.6875 L 2.8125 0 L -0.15625 0 L 5.4375 -12.546875 L 8.296875 -12.546875 L 13.90625 0 L 10.859375 0 Z M 8.828125 -4.890625 L 6.84375 -9.703125 L 4.859375 -4.890625 Z M 8.828125 -4.890625 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.979578, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.484375 -12.546875 L 4.390625 -12.546875 L 4.390625 -2.359375 L 10.6875 -2.359375 L 10.6875 0 L 1.484375 0 Z M 1.484375 -12.546875 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.307258, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.484375 -12.546875 L 4.390625 -12.546875 L 4.390625 0 L 1.484375 0 Z M 1.484375 -12.546875 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.688164, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.09375 -10.171875 L 0.078125 -10.171875 L 0.078125 -12.546875 L 11 -12.546875 L 11 -10.171875 L 6.984375 -10.171875 L 6.984375 0 L 4.09375 0 Z M 4.09375 -10.171875 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#e50101",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.266773, 185.974288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.515625 -4.4375 L 7.515625 0 L 4.609375 0 L 4.609375 -4.484375 L -0.25 -12.546875 L 2.828125 -12.546875 L 6.1875 -6.96875 L 9.53125 -12.546875 L 12.390625 -12.546875 Z M 7.515625 -4.4375 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenmortalityLogo);
export default __webpack_public_path__ + "static/media/openmortality-logo.b0c3a3eb5877c266c035d6e09eaafc9a.svg";
export { ForwardRef as ReactComponent };